import script from "./MobileRecentEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileRecentEvents.vue?vue&type=script&setup=true&lang=js"

import "./MobileRecentEvents.vue?vue&type=style&index=0&id=6b69026a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b69026a"]])

export default __exports__